"use client"

import React, { forwardRef } from "react"
import { MarketFilter, type MarketFilterOption } from "components/inputs"
import { SX_MARKET_FILTER_CONSTANTS } from "src/constants/sxMarketFilters"

export interface SxMarketFilterProps {
  selectedValues?: string[]
  onMultiFilterChange?: (selectedValues: string[]) => void
  placeholder?: string
  size?: "sm" | "md" | "lg"
  className?: string
  multiSelect?: boolean
}

const SxMarketFilter = forwardRef<HTMLDivElement, SxMarketFilterProps>(
  (
    {
      selectedValues = [],
      onMultiFilterChange,
      placeholder = "Select markets",
      size = "md",
      className = "",
      multiSelect = true,
    },
    ref
  ) => {
    // Convert SxMarketFilterOption to MarketFilterOption
    const marketFilterOptions: MarketFilterOption[] =
      SX_MARKET_FILTER_CONSTANTS.map(filter => ({
        id: filter.id,
        label: filter.label,
        value: filter.value,
      }))

    const handleFilterChange = (options: MarketFilterOption[]) => {
      const values = options.map(option => option.value)
      onMultiFilterChange?.(values)
    }

    return (
      <div ref={ref} className={className}>
        <MarketFilter
          options={marketFilterOptions}
          selectedValues={selectedValues}
          onMultiFilterChange={handleFilterChange}
          placeholder={placeholder}
          size={size}
          multiSelect={multiSelect}
        />
      </div>
    )
  }
)

SxMarketFilter.displayName = "SxMarketFilter"

export default SxMarketFilter
